import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import LiveResultBlock from "../components/atoms/LiveResultBlock";
import LotteryCard from "../components/atoms/LotteryCard";
import RecordList from "../components/atoms/RecordList";
import TimeTable from "../components/atoms/TimeTable";
import { API_URL } from "../Const";
import { Helmet } from "react-helmet";
const sampleList = require("../json/homepage.json");
const mata = require("../assets/mata_laxmi.jpg");

const Home = () => {
  const [cardList, setCardList] = useState(sampleList.data);
  const [homeData, setHomeData] = useState(null);
  const [activeGames, setActiveGames] = useState(null);
  const [loading, setLoading] = useState(true);

  // console.log(cardList);

  const getData = async () => {
    try {
      // setLoading(true);
      const response = await axios.get(API_URL + "api/homepage");
      if (response.status) {
        setLoading(false);
      }
      const listData = response.data.data;
      setHomeData(response.data);
      setCardList(listData);

      // const current = new Date();
      // const year = current.getFullYear();
      // const month = current.getMonth();
      // const day = current.getDate();

      // const getHourNMinute = (timeString) => {
      //   let [hour, minute] = timeString
      //     .split(" ")?.[0]
      //     ?.split(":")
      //     ?.map((ele) => parseInt(ele));

      //   if (
      //     timeString.toLowerCase().includes("pm") &&
      //     !timeString.startsWith("12")
      //   ) {
      //     hour += 12;
      //   }
      //   return { hour, minute };
      // };

      const activeGames = response.data.activeResult;
      // listData.forEach((ele) => {
      //   const from = getHourNMinute(ele.game_from_time);
      //   const to = getHourNMinute(ele.game_to_time);
      //   const fromTime = new Date(
      //     year,
      //     month,
      //     day,
      //     from.hour,
      //     from.minute,
      //     0,
      //     0
      //   ).getTime();
      //   let toTime;
      //   if (
      //     ele?.game_from_time?.toLowerCase()?.includes("pm") &&
      //     ele?.game_to_time?.toLowerCase()?.includes("am")
      //   ) {
      //     toTime = new Date(
      //       year,
      //       month,
      //       day + 1,
      //       to.hour,
      //       to.minute,
      //       0,
      //       0
      //     ).getTime();
      //   } else {
      //     toTime = new Date(
      //       year,
      //       month,
      //       day,
      //       to.hour,
      //       to.minute,
      //       0,
      //       0
      //     ).getTime();
      //   }

      //   const currentTime = new Date().getTime();
      //   if (currentTime > fromTime && currentTime < toTime) {
      //     activeGames.push(ele);
      //   }
      // });

      setActiveGames(activeGames);
    } catch (error) { }
  };

  useEffect(() => {
    getData();
  }, []);

  const HighLighted = ({ children }) => {
    return (
      <span className="bg-blue-900 inline-block px-2 mx-2 mb-2 rounded-xl text-white">
        {children}
      </span>
    );
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Satta Matka Casino | Kalyan, Madhur, Milan, Star Bazaar Results</title>
        <meta name="description" content="Get the latest Satta Matka casino results for Kalyan, Madhur, Milan, Star Bazaar, and Star Bazar. Live updates, charts, and tips." />
        <meta name="keywords" content="Satta, matka casino, kalyan, madhur, milan, star bazaar, star bazar, results, charts" />
        <meta property="og:title" content="Satta Matka Casino Results" />
        <meta property="og:description" content="Live Satta Matka results for Kalyan, Madhur, Milan, Star Bazaar, and Star Bazar." />
        <meta property="og:image" content={mata} />
        <meta name="twitter:card" content="summary_large_image" />
        {/* Structured Data */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Satta Matka Casino",
            "url": "https://ssbossbazar7.com",
            "description": "Get the latest Satta Matka casino results for Kalyan, Madhur, Milan, Star Bazaar, and Star Bazar. Live updates, charts, and tips.",
            "keywords": "Satta, matka casino, kalyan, madhur, milan, star bazaar, star bazar, results, charts"
          }
        `}</script>
      </Helmet>
      <div className="px-5">
        <div class="relative flex overflow-x-hidden bg-yellow-300 mb-8 text-black">
          <div class="py-12 animate-marquee whitespace-nowrap">
            <span class="text-4xl mx-4">Notice : </span>
            <span class="text-4xl mx-4">{homeData?.notice || "! Welcome to Star bazaar !"}</span>
          </div>
        </div>
        {/* <div className="mb-8 w-full h-[100px] md:h-[auto] sm:h-[auto] bg-red-700 py-6 relative overflow-hidden text-white text-5xl">
        <span className="h-[50px] md:h-[25px] absolute capitalize min-w-[295px] overflow-hidden block leftToRight text-5xl animate-marquee2 whitespace-nowrap">
          {homeData?.notice || "! Welcome to Star bazaar !"}
        </span>
      </div> */}
        <LiveResultBlock liveGames={activeGames} />
        <h1 className="text-2xl text-teal-800 mb-3  mt-5 p-5 ">
          <div className="bg-red-300 py-4">
            <HighLighted> STAR DAY</HighLighted> | MADHUR BAZAR |
            <HighLighted> STAR MORNING</HighLighted> | MADHUR MORNING |
            <HighLighted> KALYAN MATKA RESULT </HighLighted> | MADHUR DAY |
            <HighLighted> STAR DAY CHART </HighLighted> |{" "}
            <HighLighted> STAR NIGHT</HighLighted> |{" "}
            <HighLighted> STAR BAZAR</HighLighted> |{" "}
            <HighLighted> STAR MATKA</HighLighted> |{" "}
            <HighLighted> KALYAN MATKA </HighLighted> |{" "}
            <HighLighted> KALYAN MATKA TIPS </HighLighted> | MADHUR NIGHT | DP
            BOSS | MADHUR DAY CHART | MADHUR MATKA |
            {/* for SEO */}
            <HighLighted>SATTA</HighLighted> | <HighLighted>MATKA CASINO</HighLighted> | KALYAN | MADHUR | MILAN | <HighLighted>STAR BAZAR</HighLighted> | <HighLighted>RESULTS</HighLighted> | <HighLighted>CHARTS</HighLighted>
          </div>
        </h1>

        <div>
          <h1 className="bg-teal-950 text-white text-3xl tracking-widest p-3 text-center">
            !!! SATTA MATKA CASINO ALL GAME RESULTS: KALYAN, MADHUR, MILAN, STAR BAZAR !!!
          </h1>
          <div className=" lg:gap-5 gap-3 flex flex-col my-5 ">
            {cardList?.map((ele) => (
              <LotteryCard cardData={ele} />
              // <LotteryCardLoading />
            ))}
          </div>
        </div>

        <div className="lg:grid grid-cols-2 gap-10 mb-5 mt-10">
          <RecordList gamesList={cardList} type="jodi" baseRoute="/jodiChart" />
          <RecordList gamesList={cardList} type="panel" baseRoute="/panelChart" />
        </div>
        <TimeTable gamesList={cardList} />
      </div>
    </>
  );
};

export default Home;
